<template>
  <div class="globalContainer2">
    <div id="map2" ref="map">
      <div id="popupHover2" style="position: absolute"></div>
      <v-card id="insideMaps2" elevation="12" width="256">
        <v-navigation-drawer floating permanent>
          <v-list rounded>
            <v-subheader class="my-5 pb-5"> Année d'observation</v-subheader>
            <v-list-item>
              <v-slider
                id="sliderYear2"
                v-model="sliderYear"
                thumb-label="always"
                :min="2010"
                :max="2020"
                step="1"
                ticks="always"
                tick-size="4"
                @change="updateSelectedYear"
              >
              </v-slider>
            </v-list-item>
            <v-list-item>
              <v-radio-group v-model="cbFlux" @change="updateSelectedFlowType">
                <v-radio
                  v-for="flux in Object.keys(eurostats)"
                  :key="flux"
                  :label="eurostats[flux]"
                  :value="flux"
                ></v-radio>
              </v-radio-group>
            </v-list-item>
            <v-list-item>
              <span class="dotDifferentiel" style="background: rgb(26, 152, 255)"> </span><label> {{eurostats[selectedFluxType]}}</label><br>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </v-card>
      <div class="datavizContainer2">
        <DatavizScatter :selected="selected" :flowType="selectedFluxType" :year="selectedYear" :key="key" />
      </div>
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import { ScatterplotLayer, TextLayer} from "@deck.gl/layers";
import { MapboxLayer } from "@deck.gl/mapbox";
import dataEurostats from "../data/all_years_eurostats.json";
import dataEurostatsMonth from "../data/all_month_eurostats.json";

import * as d3 from "d3";
import DatavizScatter from "@/components/DatavizScatter.vue";

mapboxgl.accessToken =
  "pk.eyJ1IjoibmFoZWxvdSIsImEiOiJjazUxOG9yNDcwcDUyM3NtaTVzMnd5ejdrIn0.hFTRn-SVqOhufKAcRCnYLA";

export default {
  props: {
    selected: {
      type: String,
    },
  },
  data() {
    return {
      key:0,
      dataEurostats: dataEurostats,
      dataEurostatsMonth: null,      
      drawer: true,
      airports: [],
      dcat_years: ["2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
      map: null,
      sliderYear: "2010",
      selectedYear: "2010",
      cbFlux: "pas_trs",
      selectedFluxType: "pas_trs",
      inFlowColors: [255, 255, 0],
      outFlowColors: [177, 0, 38],
      inFlowColorsInc: [255, 255, 255],
      outFlowColorsInc: [0, 153, 255],
      eurostats: {
          pas_crd: "Nombre de passagers transportés",
          pas_trs: "Nombre de passagers en transit direct",
          acm:
            "Mouvements d’avions  commerciaux et non commerciaux (passagers, fret et courrier)",
          cacm: "Mouvements d’avions commerciaux (passagers, fret et courrier)",
        },
        dgac: {
          Dessertes: "Nombre total de dessertes",
          Desserte_reg: "Nombre de dessertes régulières",
          Desserte_Non_reg: "Nombre de dessertes non régulières",
          Pax_total:
            "Nombre total de passagers locaux + en transit des vols commerciaux (sans double compte)",
          Pax_reg: "Nombre total de passagers d'un vol régulier",
          Pax_Non_reg: "Nombre total de passagers d'un vol non régulier",
          Fret_Total: "Poids total estimé de marchandises d'un vol",
        },
      termes: {
        eurostats: {
          pas_crd: "Nombre de passagers transportés",
          pas_trs: "Nombre de passagers en transit direct",
          // pas_trf: "Nombre de passagers transférés",
          frm_ld_nld:
            "Quantité estimée de marchandises chargée et déchargée : fret et courrier",
          acm:
            "Mouvements d’avions  commerciaux et non commerciaux (passagers, fret et courrier)",
          cacm: "Mouvements d’avions commerciaux (passagers, fret et courrier)",
        },
        dgac: {
          Dessertes: "Nombre total de dessertes",
          Desserte_reg: "Nombre de dessertes régulières",
          Desserte_Non_reg: "Nombre de dessertes non régulières",
          Pax_total:
            "Nombre total de passagers locaux + en transit des vols commerciaux (sans double compte)",
          Pax_reg: "Nombre total de passagers d'un vol régulier",
          Pax_Non_reg: "Nombre total de passagers d'un vol non régulier",
          Fret_Total: "Poids total estimé de marchandises d'un vol",
        },
      },
      dataMonthly:null,
      mini: true,
      accessToken:
        "pk.eyJ1IjoibmFoZWxvdSIsImEiOiJjazUxOG9yNDcwcDUyM3NtaTVzMnd5ejdrIn0.hFTRn-SVqOhufKAcRCnYLA",
      mapStyle: "mapbox://styles/nahelou/cjzokkh6s0rq31cqnu7blj9bd",
      latitude: 46.4832668,
      longitude: 2.1491635,
      zoom: 5,
      bearing: 40,
      pitch: 0,
    };
  },
  created() {
    this.map = null;
    this.selected = this.$props.selected;
  },
  mounted() {

    this.map = new mapboxgl.Map({
      container: "map2",
      style: "mapbox://styles/nahelou/cjfgvxuancvbz2rsvvudroksj",
      center: [this.longitude, this.latitude],
      zoom: this.zoom,
      pitch: this.pitch,
    });
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.scrollZoom.disable();

    this.map.on("load", () => {
      this.dataEurostatsMonth = dataEurostatsMonth;
      this.addScatterLayer();
    });

  },
  methods: {
    updateSelectedYear(event) {
      if (this.selectedYear != event) {
        this.selectedYear = event;
      }
      this.addScatterLayer();
    },
    updateSelectedFlowType(event) {
      if (this.selectedFluxType != event)
        this.selectedFluxType = event;
        this.addScatterLayer();
    },
    addScatterLayer() {
      if (this.map.getLayer("scatterLayer")) {
        this.map.removeLayer("scatterLayer");
        this.map.removeLayer("scatterLayerSelected");
        this.map.removeLayer("text-layer");

      }
      let dataToScatter = this.dataEurostats.filter((e)=>{
        return ((e.annee == this.selectedYear) && (e.ville != this.selected) && (e[this.selectedFluxType] > 0))
      });
      let dataToScatterSelected = this.dataEurostats.filter((e)=>{
        return ((e.annee == this.selectedYear) && (e.ville == this.selected) && (e[this.selectedFluxType] > 0))
      });

      let listeValues = [];

      dataToScatter.forEach(element => {
        listeValues.push(element[this.selectedFluxType])
      });
      if(dataToScatterSelected[0]) listeValues.push(dataToScatterSelected[0][this.selectedFluxType]);
      

        let maxOut = d3.max(Object.values(listeValues));
        let meanOut = d3.mean(Object.values(listeValues));
        let minOut = d3.min(Object.values(listeValues));

        let valued3 = d3
          .scaleLinear(10)
          .domain([minOut, meanOut, maxOut])
          .range([20, 50, 80, 100]);
          const scatterLayer = new MapboxLayer({
          id: "scatterLayer",
          type: ScatterplotLayer,
          data: dataToScatter,
          getPosition: (d) => [parseFloat(d.lng), parseFloat(d.lat)],
          radiusScale: 500,
          getRadius: (d) => {
            return valued3(d[this.selectedFluxType])>0?valued3(d[this.selectedFluxType]):valued3(d[this.selectedFluxType])*-1},
          getColor: this.outFlowColorsInc,
          radiusMinPixels: 2,
          pickable : true,
          onHover: (info) => this.hover1(info.object, info.x, info.y),
        });
          const scatterLayerSelected = new MapboxLayer({
          id: "scatterLayerSelected",
          type: ScatterplotLayer,
          data: dataToScatterSelected,
          getPosition: (d) => [parseFloat(d.lng), parseFloat(d.lat)],
          radiusScale: 500,
          getRadius: (d) => valued3(d[this.selectedFluxType]),
          getColor: this.inFlowColors,
          radiusMinPixels: 2,
          pickable : true,
          onHover: (info) => this.hover1(info.object, info.x, info.y),
        });
          const Textlayer = new MapboxLayer({
          id: 'text-layer',
          type: TextLayer,
          data: dataToScatterSelected,
          pickable: true,
          getPosition: (d) => [parseFloat(d.lng), parseFloat(d.lat)+0.5],
          getText: (d) => d.ville,
          getSize: 20,
          backgroundColor: [250,250,250,250],
          getAngle: 0,
          getTextAnchor: 'middle',
          getAlignmentBaseline: 'top'
  });
        this.map.addLayer(Textlayer);
        this.map.addLayer(scatterLayer);
        this.map.addLayer(scatterLayerSelected);
        this.key = this.key + 1;
    },
        hover1(object, x, y) {
      const el = document.getElementById("popupHover2");

      if (object) {
        el.innerHTML = "";
        let tableau = document.createElement("table");
        tableau.class = "table is-hoverable";
        tableau.cellspacing = "0";
        tableau.width = "80%";
        let villeH2 = document.createElement("div");
        villeH2.className = "subtitle";
        villeH2.innerHTML = object.ville.toUpperCase();
        let body = document.createElement("tbody");
        for (let i in this.termes.eurostats) {
          let data = document.createElement("tr");
          let type = document.createElement("td");
          type.innerHTML = this.termes.eurostats[i];
          data.appendChild(type);
          let n = document.createElement("td");
          n.innerHTML = object[i];
          data.appendChild(n);
          body.appendChild(data);
        }
        tableau.appendChild(body);
        el.appendChild(villeH2);
        el.appendChild(tableau);

        el.style.display = "block";
        el.style.left = x + 20 + "px";
        el.style.top = y + 30 + "px";
        el.style.backgroundColor = "white";
        el.style.borderRadius = "2px";
        el.style.padding = "10px";
        el.style.margin = "10px";
        el.style.lineHeight = "2";
        el.style.zIndex = "9999";
      } else {
        el.style.display = "none";
      }
    },
    },
  components: {
    DatavizScatter,
  },
};
</script>

<style>
.mapboxgl-ctrl-zoom-in {
  background-image: url(https://www.flaticon.com/svg/static/icons/svg/748/748113.svg) !important;
  background-size:50%;
  background-position: center;
}
.mapboxgl-ctrl-zoom-out {
  background-image: url(https://www.flaticon.com/svg/static/icons/svg/748/748114.svg) !important;
  background-size:50%;
  background-position: center;
  }
  .mapboxgl-ctrl-compass {
  background-image: url(https://www.flaticon.com/svg/static/icons/svg/803/803501.svg) !important;
  background-size:50%;
  background-position: center;
  }
#insideMaps2 {
  top: 10vh;
  margin: 1%;
  background-color: #fff;
  position: absolute;
  z-index: 1;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  font-family: "Open Sans", sans-serif;
}
.datavizContainer2 {
  
  top: 15vh;
  right: 0%;
  background-color: rgba(206, 206, 206, 0.4);
  position: absolute;
  z-index: 1;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  font-family: "Open Sans", sans-serif;
}
#map2 {
  height: 100vh;
  z-index: 0;
}
#sliderYear2 {
  cursor: pointer;
}
</style>
